(function ($) {
    const $fn = $(".comp_booking_form");

    if($fn.length) {
        reInitBookingForm($fn);
    }
})(jQuery);